export default "__VITE_ASSET__BhKtq2qb__"